import { Component, Input, OnInit } from '@angular/core';
import { LogTimeLineItem } from '@interfaces';
import { uniqBy } from 'lodash';

export function ValidateAutocomplete(): object {
  return { required: true };
}

@Component({
  selector: 'historic',
  templateUrl: './historic.component.html',
  styleUrls: ['./historic.component.scss'],
})
export class HistoricComponent implements OnInit {
  @Input() logs: LogTimeLineItem[] = [];
  @Input() isOpeningMaintenanceDialog: Boolean = false;

  ngOnInit(): void {
    this.logs = this.logs.map((log) => {
      if (log.rating) {
        const stars = [
          'icon-star-outline',
          'icon-star-outline',
          'icon-star-outline',
          'icon-star-outline',
          'icon-star-outline'
        ];

        for (let i = 0; i < log.rating; i++) {
          stars[i] = 'icon-star';
        }

        log.stars = stars;
      }

      return log;
    });

    this.logs = uniqBy(this.logs, (log) => log.content + log.createdAt);
  }
}
